(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertaro-featured-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : null;
      const opener = target?.closest('[data-vfr-open]');
      if (opener) {
        const dialog = document.getElementById(opener.dataset.vfrOpen);
        if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
      }
      const close = target?.closest('[data-vfr-close]');
      if (close) close.closest('dialog').close();
      if (target?.matches('dialog.vfr__dialog')) {
        const rect = target.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) target.close();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertaro-features"] && !Shopify.designMode) return;
  try {
    
function initVertaroFeatures(scope){scope.querySelectorAll('.vf:not([data-vf-ready])').forEach(root=>{root.dataset.vfReady='true';const rail=root.querySelector('.vf-rail'),buttons=root.querySelectorAll('[data-vf-dir]');function update(){buttons.forEach(button=>{button.disabled=Number(button.dataset.vfDir)<0?rail.scrollLeft<3:rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-3;});}buttons.forEach(button=>button.addEventListener('click',()=>{const card=rail.querySelector('.vf-card');if(!card)return;rail.scrollBy({left:Number(button.dataset.vfDir)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));rail.addEventListener('scroll',update,{passive:true});const observer=new ResizeObserver(update);observer.observe(rail);root.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});update();});}
initVertaroFeatures(document);document.addEventListener('shopify:section:load',event=>initVertaroFeatures(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertaro-photo-wall"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vertaro-photo-wall')) {
  customElements.define('vertaro-photo-wall', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.grid = this.querySelector('.vpw__grid');
      if (!this.grid) return;
      this.cards = [...this.querySelectorAll('.vpw__card')];
      this.controller = new AbortController();
      this.toggleAttribute('data-collapsed', this.cards.length > 6);
      this.addEventListener('shopify:block:select', () => { this.removeAttribute('data-collapsed'); this.schedule(); }, { signal: this.controller.signal });
      if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
        this.intersection = new IntersectionObserver((entries) => {
          if (entries.some(entry => entry.isIntersecting)) this.activate();
        }, { rootMargin: '400px 0px' });
        this.intersection.observe(this);
      } else {
        this.activate();
      }
    }

    activate() {
      if (this.active || !this.isConnected) return;
      this.active = true;
      this.intersection?.disconnect();
      this.grid.dataset.masonry = '';
      this.resize = new ResizeObserver(() => this.schedule());
      this.cards.forEach(card => this.resize.observe(card.firstElementChild));
      this.resize.observe(this.grid);
      this.schedule();
    }

    schedule() {
      if (this.frame || !this.active || !this.isConnected) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.layout();
      });
    }

    layout() {
      const gap = window.matchMedia('(max-width:749px)').matches ? 12 : 18;
      const spans = this.cards.map(card => 'span ' + Math.ceil(card.firstElementChild.getBoundingClientRect().height + gap));
      this.cards.forEach((card, index) => {
        if (card.style.gridRowEnd !== spans[index]) card.style.gridRowEnd = spans[index];
      });
      if (!this.previewFrame) this.previewFrame = requestAnimationFrame(() => {
        this.previewFrame = 0;
        if (!this.isConnected) return;
        const top = this.grid.getBoundingClientRect().top;
        const height = Math.ceil(Math.max(0, ...this.cards.slice(0, 6).map(card => card.firstElementChild.getBoundingClientRect().bottom - top))) + 'px';
        if (this.style.getPropertyValue('--vpw-preview-height') !== height) this.style.setProperty('--vpw-preview-height', height);
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.intersection?.disconnect();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.previewFrame);
      this.frame = 0;
      this.previewFrame = 0;
      this.active = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertaro-review-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vertaro-review-order')) {
    customElements.define('vertaro-review-order', class extends HTMLElement {
      connectedCallback() {
        this.limit = 8;
        this.attempts = 0;
        this.pending = false;
        this.near = false;
        this.more = this.querySelector('.vertaro-review-order__more');
        this.onMore = () => { this.limit += 8; this.attempts = 0; this.update(); };
        this.more.addEventListener('click', this.onMore);
        this.observer = new MutationObserver(() => this.queue());
        this.observer.observe(this, {childList: true, subtree: true});
        this.intersection = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.near = true; this.update(); }
        }, {rootMargin: '400px'});
        this.intersection.observe(this);
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.intersection?.disconnect();
        this.more?.removeEventListener('click', this.onMore);
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
      }
      queue() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }
      update() {
        const grid = this.querySelector('.jdgm-grid-body');
        if (!grid) return;
        const cards = Array.from(grid.querySelectorAll(':scope > .jdgm-review-card'));
        if (!cards.length) return;
        const priorities = Array.from(this.querySelectorAll('[data-review-photo]'), item => item.dataset.reviewPhoto);
        const photo = card => (card.querySelector('img')?.getAttribute('src') || '').split('?')[0].split('/').pop();
        const rank = card => { const i = priorities.indexOf(photo(card)); return i < 0 ? priorities.length : i; };
        const sorted = cards.map((card, i) => ({card, i})).sort((a,b) => rank(a.card) - rank(b.card) || a.i - b.i);
        sorted.forEach(({card}, i) => {
          card.style.order = String(i);
          card.classList.toggle('v-order-hidden', i >= this.limit);
        });
        this.dataset.sorting = 'true';
        const nativeMore = this.querySelector('.jm-show-more-button');
        this.more.hidden = cards.length <= this.limit && !nativeMore;
        const loaded = new Set(cards.map(photo));
        const missing = priorities.slice(0, this.limit).some(key => !loaded.has(key));
        const needsMore = missing || cards.length < this.limit;
        if (this.near && needsMore && nativeMore && !nativeMore.disabled && !this.pending && this.attempts < 12) {
          this.pending = true;
          this.attempts += 1;
          nativeMore.click();
          this.timer = setTimeout(() => { this.pending = false; this.update(); }, 1000);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
